import { RootState } from "../../rootReducer";

export const selectIsUpdatingUserDepartment = (state: RootState) =>
  state.updateUserDepartment.loading;
export const updateUserDepartmentErrorMessage = (state: RootState) =>
  state.updateUserDepartment.error;
export const updateUserDepartmentResponse = (state: RootState) =>
  state.updateUserDepartment.updateUserDepartmentResponse;
